export default __webpack_public_path__ + "static/media/fotoPrincipal_Dashport_bajaResolucion.c40c3aeb.jpg";